document.addEventListener("DOMContentLoaded", () => {
	const cards = document.querySelectorAll(".shop-the-look__card");

	cards.forEach((card) => {
		const pins = card.querySelectorAll(".product-pin");
		const productsContainer = card.querySelector(
			".shop-the-look__card-products",
		);

		if (!pins.length || !productsContainer) return;

		// --- Helper: Show details of a pin inside the card target ---
		function showDetails(pin) {
			const details = pin.nextElementSibling; // .product-pin__detais
			if (!details) return;

			// Replace inner HTML inside card-products
			productsContainer.innerHTML = details.innerHTML;
		}

		// --- Helper: Open pin zoom UI ---
		function openPin(pin) {
			pins.forEach((p) => closePin(p)); // close all others
			pin.classList.add("active");

			const zoomImage = pin.querySelector(".product-pin__zoom-image");
			if (zoomImage) {
				zoomImage.style.setProperty("--account-popover-opacity", "1");
				zoomImage.style.setProperty("--account-popover-y", "0");
			}
		}

		// --- Helper: Close pin ---
		function closePin(pin) {
			pin.classList.remove("active");

			const zoomImage = pin.querySelector(".product-pin__zoom-image");
			if (zoomImage) {
				zoomImage.style.setProperty("--account-popover-opacity", "0");
				zoomImage.style.setProperty("--account-popover-y", "20px");
			}
		}

		// --- 1. Show first pin's details on load ---
		const firstPin = pins[0];
		showDetails(firstPin);

		// --- 2. Handle zoom button interactions ---
		pins.forEach((pin) => {
			const zoomBtn = pin.querySelector(".product-pin__zoom");
			if (!zoomBtn) return;

			// CLICK → switch pin
			zoomBtn.addEventListener("click", (event) => {
				event.stopPropagation();

				if (!pin.classList.contains("active")) {
					openPin(pin);
					showDetails(pin);
				}
			});

			// MOUSEOVER → switch pin
			zoomBtn.addEventListener("mouseover", () => {
				if (!pin.classList.contains("active")) {
					openPin(pin);
					showDetails(pin);
				}
			});

			// MOUSELEAVE → close pin (but not if it's the first one)
			// zoomBtn.addEventListener("mouseleave", () => {
			//   // Optional: keep last clicked pin open
			//   if (pin === firstPin) return;

			//   closePin(pin);
			// });
		});
	});
});
